// extracted by mini-css-extract-plugin
module.exports = {"AgeSlider":"AgeSlider_AgeSlider__2BFet","Slider":"AgeSlider_Slider__8izBF","filterHeader":"AgeSlider_filterHeader__1_Q_H","filterIcon":"AgeSlider_filterIcon__10630"};